import { apiClient } from 'shared/lib/apiClient';
import type { DashboardAccess, PartnerStatusResponse } from '../types';

export const partnerPortalService = {
  async getStatus(): Promise<PartnerStatusResponse> {
    const { data } = await apiClient.get<PartnerStatusResponse>(
      '/partner/me/status',
    );
    return data;
  },

  async getDashboardAccess(revealToken: string): Promise<DashboardAccess> {
    const { data } = await apiClient.get<DashboardAccess>(
      '/partner/me/dashboard-access',
      { headers: { Authorization: `Bearer ${revealToken}` } },
    );
    return data;
  },
};
